import React, { useState } from 'react';

import { Button } from '@mui/material';
import { sendNewPassword } from 'config/requests/auth';
import { AuthLayout } from 'layouts/components/AuthLayout/AuthLayout';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { PasswordVisibilityIconButton } from 'shared/mui/IconButtons/PasswordVisibilityIconButton/PasswordVisibilityIconButton';
import { TextField } from 'shared/mui/TextField/TextField';

export const SetNewPassword = (): JSX.Element => {
  const translate = useTypedTranslate();

  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isRepeatPasswordVisible, setIsRepeatPasswordVisible] = useState(false);

  const { token } = useParams();
  const notify = useNotify();
  const navigate = useNavigate();

  const submit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setShowErrorAlert(false);
    if (token) {
      if (password !== repeatPassword) {
        setShowErrorAlert(true);
        return;
      }
      sendNewPassword(token, password)
        .then((res) => {
          notify(res.data.message, { type: 'success' });
          navigate('/login');
        })
        .catch((e) => notify(e.data.errors[0].title, { type: 'error' }));
    }
  };

  return (
    <AuthLayout title={translate('app.login.newPassword')}>
      <Box>
        {showErrorAlert && (
          <Alert severity="error" sx={{ marginBottom: '24px' }}>
            {translate('app.login.passwordsDoNotMatch')}
          </Alert>
        )}
        <form noValidate onSubmit={submit}>
          <TextField
            InputProps={{
              endAdornment: (
                <PasswordVisibilityIconButton
                  isVisible={isPasswordVisible}
                  onClick={() => setIsPasswordVisible((value) => !value)}
                />
              ),
            }}
            fullWidth
            id="password"
            label={translate('app.login.newPass')}
            margin="normal"
            onChange={(e) => setPassword(e.target.value)}
            size="medium"
            sx={{ marginBottom: '24px !important' }}
            type={isPasswordVisible ? 'text' : 'password'}
            value={password}
            variant="outlined"
          />
          <TextField
            InputProps={{
              endAdornment: (
                <PasswordVisibilityIconButton
                  isVisible={isRepeatPasswordVisible}
                  onClick={() => setIsRepeatPasswordVisible((value) => !value)}
                />
              ),
            }}
            fullWidth
            id="repeatPassword"
            label={translate('app.login.confirmPass')}
            margin="normal"
            onChange={(e) => setRepeatPassword(e.target.value)}
            size="medium"
            sx={{ marginBottom: '24px !important' }}
            type={isRepeatPasswordVisible ? 'text' : 'password'}
            value={repeatPassword}
            variant="outlined"
          />
          <Box sx={{ display: 'flex', gap: '16px' }}>
            <Button fullWidth onClick={() => navigate('login')} variant="outlined">
              {translate('app.buttons.back')}
            </Button>
            <Button disabled={!password.length} fullWidth type="submit" variant="contained">
              {translate('app.buttons.continue')}
            </Button>
          </Box>
        </form>
      </Box>
    </AuthLayout>
  );
};
